export default "__VITE_ASSET__CSUerXtm__"